import React from 'react';
import { Modal } from 'react-bootstrap';
import AppButton from 'components/FormsUI/AppButton/appButton';

function RefreshUser() {
    return (<div className="container">
        {/* <Modal show={true}>
            <Modal.Header >
                <Modal.Title>Refresh User</Modal.Title>
                <span style={{ cursor: "pointer" }} >X</span>
            </Modal.Header>
            <Modal.Body>
                <div>Your session will end soon</div>
            </Modal.Body>
            <Modal.Footer>
                <div className='col-2'>
                    <AppButton label="Continue" ></AppButton>
                </div>
                <div className='col-2'>
                    <AppButton label="Logout" color="secondary" ></AppButton>
                </div>
            </Modal.Footer>
        </Modal> */}
sssss
    </div>)
};
export default RefreshUser;